module.exports = __webpack_public_path__ + "img/chengy-icon.124baf05.png";